import request from 'src/network';

const apiPath = '/api/ai_agent/sources';

export function getModelService() {
    return request.GET<string>(apiPath);
}

export function getModelServiceV2() {
    return request.GET<string>('/api/ai_agent_v2/agent/models');
}